import React, { useEffect, useState } from 'react';
import { appAgentService } from '../../services/central-api/app-agent';
import { StyleProp, TextStyle, View } from 'react-native';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number;
    setValue: React.Dispatch<SetStateCallback<number>>;
    zIndex?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    unitId: number;
}

export default function UnitFinishEarlyDropdown({ value, setValue, unitId, zIndex, labelStyle, viewStyle, label }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getFinishEarlyReasons() {
        try {
            const response = await appAgentService.getFinishEarlyReasons(unitId);
            setItems(response.map(earlyFinishReason => ({
                label: earlyFinishReason.name, value: earlyFinishReason.id
            })));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getFinishEarlyReasons();
    }, []);

    return (<View style={{ flexDirection: 'column', gap: 16 }}>
        <FilterDropdown
            label={label ?? translate('finishEarlyReason')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    </View>);
}
